import Invoice from "./Invoice";
import Job from "./Job";
import Payroll from "./Payroll";

const Status = {
  Invoice,
  Job,
  Payroll,
};

export default Status;
